<template>
    <table class="table table-striped">
        <thead>
            <tr>
                <th>#</th>
                <th>Name</th>
                <th>Specification</th>
                <th>Quantity</th>
                <th>Total</th>
                <th>Operation</th>
            </tr>
        </thead>
        <tbody>
            <template v-if="myCartList.length">
                <tr v-for="(item, index) in myCartList" :key="`${item.product_id}-${item.storage_id}`">
                    <td>{{ index + 1 }}</td>
                    <td>{{ item.name }}</td>
                    <td>{{ item.spec_name }}</td>
                    <td>
                        <template v-if="item.valid">
                            <cart-quantity :cart-item="item"></cart-quantity>
                        </template>
                        <template v-else>
                            商品已下架或刪除
                        </template>
                    </td>
                    <td>{{ item.amount }}
                    </td>
                    <td>
                        <cart-remove-btn :cart-item="item"></cart-remove-btn>
                        <!--
                    <form action="{{ url("/api/carts/delete/{$item->product->id}") }}" method="post">
                        @csrf
                        @method('delete')
                        <input type="hidden" name="storage" value="{{ $item->storage_id }}">
                    </form>
                    -->
                    </td>
                </tr>
            </template>
            <template v-else>
                <tr>
                    <td colspan="6">No any item in cart.</td>
                </tr>
            </template>
        </tbody>
    </table>
</template>
<script>
    import eventHub from '../../../library/event-hub';

    export default {
        props: {
            cartList: {
                default() {
                    return [];
                }
            }
        },
        data() {
            return {
                myCartList: []
            };
        },
        mounted() {
            this.myCartList = this.cartList;
            eventHub.$on('cart-updated', newList => this.myCartList = newList);
        }
    }
</script>
<style lang="">

</style>